import { initialState } from '../initialState.js';
import { createSlice } from '@reduxjs/toolkit';
import {
  getMechanicBalance,
  getUserData,
  logIn,
  logOut,
  refreshUser,
} from './operations.js';

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  {
    state.isLoading = false;
    state.error = action.payload;
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState.auth,
  reducers: {},
  extraReducers: builder =>
    builder
      //Login +
      .addCase(logIn.pending, handlePending)
      .addCase(logIn.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoggedIn = true;

        state.accessToken = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;
      })
      .addCase(logIn.rejected, handleRejected)

      // Logout +
      .addCase(logOut.pending, handlePending)
      .addCase(logOut.fulfilled, state => {
        return { ...initialState.auth, isLoggedIn: false };
      })
      .addCase(logOut.rejected, handleRejected)

      // Get user data +
      .addCase(getUserData.pending, handlePending)
      .addCase(getUserData.fulfilled, (state, action) => {
        state.userData = {
          ...state.userData, // Зберігаємо поточні значення
          ...action.payload, // Додаємо нові дані
        };

        state.isLoading = false;
      })
      .addCase(getUserData.rejected, handleRejected)

      //Get mechanic balance data +
      .addCase(getMechanicBalance.pending, handlePending)
      .addCase(getMechanicBalance.fulfilled, (state, action) => {
        state.balance = action.payload;
        state.isLoading = false;
      })
      .addCase(getMechanicBalance.rejected, handleRejected)

      //Refresh +
      .addCase(refreshUser.pending, state => {
        state.isRefreshing = true;
        state.isLoading = true;
        state.error = null;
      })

      .addCase(refreshUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isRefreshing = false;
        state.isLoggedIn = true;

        state.accessToken = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;
        state.userData = {
          ...state.userData,
          ...action.payload.user,
        };
      })

      .addCase(refreshUser.rejected, (state, action) => {
        state.isRefreshing = false;
        state.isLoading = false;
        state.isLoggedIn = false;

        state.accessToken = null;
        state.refreshToken = null;
        state.userData = null;

        state.error = action.payload;
      }),
});

export default authSlice.reducer;
